import { useAppStore } from '../../state/useAppStore';
import { isAssetGraphic, isBuiltinGraphic, type SymbolGraphic } from '../../../symbols/model';
import { monochromeSvg } from '../../../symbols/tint';
import { ColourControl } from './ColourControl';

export function SymbolColourControl({
  graphic,
  colour,
  tint,
  id,
  onColour,
  onTint,
  label = 'Colour',
}: {
  readonly graphic: SymbolGraphic;
  readonly colour: string;
  readonly tint?: string | null;
  readonly id: string;
  readonly onColour: (colour: string) => void;
  readonly onTint: (tint: string | null) => void;
  readonly label?: string;
}) {
  const assets = useAppStore((s) => s.project.symbolAssets);
  if (!isAssetGraphic(graphic))
    return (
      <ColourControl
        id={id}
        label={isBuiltinGraphic(graphic) ? 'Colour' : label}
        value={colour}
        onChange={onColour}
      />
    );
  const asset = assets.find((a) => a.id === graphic.assetId);
  if (!asset || !monochromeSvg(asset))
    return (
      <p className="style-help">
        Original colours.{' '}
        {asset?.mimeType === 'image/png'
          ? 'PNG artwork keeps its colours and transparency.'
          : 'Only SVG artwork with one effective colour can be tinted.'}
      </p>
    );
  return (
    <>
      <div className="style-field style-field-inline">
        <label htmlFor={`${id}-mode`}>Colours</label>
        <select
          id={`${id}-mode`}
          value={tint ? 'tint' : 'original'}
          onChange={(e) => onTint(e.target.value === 'original' ? null : colour)}
        >
          <option value="original">Original colours</option>
          <option value="tint">Tint</option>
        </select>
      </div>
      {tint ? <ColourControl id={id} label="Tint colour" value={tint} onChange={onTint} /> : null}
    </>
  );
}
